<template>
  <section v-if="images.length > 0" id="gallery" class="py-16 bg-white">
    <div class="container mx-auto px-4">
      <h2 class="section-title text-gascon-blue">Dans vos cuisines !</h2>

      <!-- Decorative line -->
      <div class="flex justify-center mb-12">
        <div class="w-16 h-1 bg-gascon-gold"></div>
      </div>

      <!-- Image mosaic grid -->
      <!-- All images same height, 3 squares + 1 rectangle per row (desktop) -->
      <!-- 2 squares + 1 rectangle per row (mobile) -->
      <div ref="gridContainer" class="max-w-5xl mx-auto">
        <!-- Desktop layout -->
        <div class="hidden md:flex flex-col gap-4">
          <!-- Row 1: square, square, RECT, square -->
          <div class="flex gap-4" :style="{ height: rowHeight + 'px' }">
            <div ref="squareRef" class="overflow-hidden" :style="{ width: rowHeight + 'px', height: rowHeight + 'px' }">
              <img v-if="displayImages[0]" :src="displayImages[0].url" :alt="displayImages[0].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
            <div class="overflow-hidden" :style="{ width: rowHeight + 'px', height: rowHeight + 'px' }">
              <img v-if="displayImages[1]" :src="displayImages[1].url" :alt="displayImages[1].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
            <div class="flex-1 overflow-hidden">
              <img v-if="displayImages[2]" :src="displayImages[2].url" :alt="displayImages[2].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
            <div class="overflow-hidden" :style="{ width: rowHeight + 'px', height: rowHeight + 'px' }">
              <img v-if="displayImages[3]" :src="displayImages[3].url" :alt="displayImages[3].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
          </div>
          <!-- Row 2: RECT, square, square, square -->
          <div class="flex gap-4" :style="{ height: rowHeight + 'px' }">
            <div class="flex-1 overflow-hidden">
              <img v-if="displayImages[4]" :src="displayImages[4].url" :alt="displayImages[4].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
            <div class="overflow-hidden" :style="{ width: rowHeight + 'px', height: rowHeight + 'px' }">
              <img v-if="displayImages[5]" :src="displayImages[5].url" :alt="displayImages[5].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
            <div class="overflow-hidden" :style="{ width: rowHeight + 'px', height: rowHeight + 'px' }">
              <img v-if="displayImages[6]" :src="displayImages[6].url" :alt="displayImages[6].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
            <div class="overflow-hidden" :style="{ width: rowHeight + 'px', height: rowHeight + 'px' }">
              <img v-if="displayImages[7]" :src="displayImages[7].url" :alt="displayImages[7].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
          </div>
          <!-- Row 3: square, RECT, square, square -->
          <div class="flex gap-4" :style="{ height: rowHeight + 'px' }">
            <div class="overflow-hidden" :style="{ width: rowHeight + 'px', height: rowHeight + 'px' }">
              <img v-if="displayImages[8]" :src="displayImages[8].url" :alt="displayImages[8].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
            <div class="flex-1 overflow-hidden">
              <img v-if="displayImages[9]" :src="displayImages[9].url" :alt="displayImages[9].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
            <div class="overflow-hidden" :style="{ width: rowHeight + 'px', height: rowHeight + 'px' }">
              <img v-if="displayImages[10]" :src="displayImages[10].url" :alt="displayImages[10].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
            <div class="overflow-hidden" :style="{ width: rowHeight + 'px', height: rowHeight + 'px' }">
              <img v-if="displayImages[11]" :src="displayImages[11].url" :alt="displayImages[11].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
          </div>
        </div>

        <!-- Mobile layout -->
        <div class="md:hidden flex flex-col gap-2">
          <!-- Row 1: square, square, RECT -->
          <div class="flex gap-2" :style="{ height: mobileRowHeight + 'px' }">
            <div ref="mobileContainerRef" class="overflow-hidden" :style="{ width: mobileRowHeight + 'px', height: mobileRowHeight + 'px' }">
              <img v-if="displayImages[0]" :src="displayImages[0].url" :alt="displayImages[0].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
            <div class="overflow-hidden" :style="{ width: mobileRowHeight + 'px', height: mobileRowHeight + 'px' }">
              <img v-if="displayImages[1]" :src="displayImages[1].url" :alt="displayImages[1].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
            <div class="flex-1 overflow-hidden">
              <img v-if="displayImages[2]" :src="displayImages[2].url" :alt="displayImages[2].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
          </div>
          <!-- Row 2: RECT, square, square -->
          <div class="flex gap-2" :style="{ height: mobileRowHeight + 'px' }">
            <div class="flex-1 overflow-hidden">
              <img v-if="displayImages[3]" :src="displayImages[3].url" :alt="displayImages[3].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
            <div class="overflow-hidden" :style="{ width: mobileRowHeight + 'px', height: mobileRowHeight + 'px' }">
              <img v-if="displayImages[4]" :src="displayImages[4].url" :alt="displayImages[4].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
            <div class="overflow-hidden" :style="{ width: mobileRowHeight + 'px', height: mobileRowHeight + 'px' }">
              <img v-if="displayImages[5]" :src="displayImages[5].url" :alt="displayImages[5].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
          </div>
          <!-- Row 3: square, RECT, square -->
          <div class="flex gap-2" :style="{ height: mobileRowHeight + 'px' }">
            <div class="overflow-hidden" :style="{ width: mobileRowHeight + 'px', height: mobileRowHeight + 'px' }">
              <img v-if="displayImages[6]" :src="displayImages[6].url" :alt="displayImages[6].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
            <div class="flex-1 overflow-hidden">
              <img v-if="displayImages[7]" :src="displayImages[7].url" :alt="displayImages[7].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
            <div class="overflow-hidden" :style="{ width: mobileRowHeight + 'px', height: mobileRowHeight + 'px' }">
              <img v-if="displayImages[8]" :src="displayImages[8].url" :alt="displayImages[8].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
          </div>
          <!-- Row 4: square, square, RECT -->
          <div class="flex gap-2" :style="{ height: mobileRowHeight + 'px' }">
            <div class="overflow-hidden" :style="{ width: mobileRowHeight + 'px', height: mobileRowHeight + 'px' }">
              <img v-if="displayImages[9]" :src="displayImages[9].url" :alt="displayImages[9].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
            <div class="overflow-hidden" :style="{ width: mobileRowHeight + 'px', height: mobileRowHeight + 'px' }">
              <img v-if="displayImages[10]" :src="displayImages[10].url" :alt="displayImages[10].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
            <div class="flex-1 overflow-hidden">
              <img v-if="displayImages[11]" :src="displayImages[11].url" :alt="displayImages[11].alt || 'Plat de nos clients'" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GallerySection',
  props: {
    images: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      containerWidth: 1024,
      mobileContainerWidth: 375
    }
  },
  computed: {
    displayImages() {
      return this.images.filter(img => img.url).slice(0, 12)
    },
    // Desktop: 4 images per row, 3 squares + 1 flex
    // Row width = 3 * squareSize + rectWidth + 3 * gap
    // squareSize = rowHeight
    // So: containerWidth = 3 * rowHeight + rectWidth + 3 * 16 (gap-4 = 16px)
    // rectWidth fills remaining space, so: containerWidth = 3 * rowHeight + 48 + rectWidth
    // We want squares to be nice size, calculate based on container
    rowHeight() {
      // 3 squares + gaps (3 * 16px) = container width - rect width
      // rect takes remaining space with flex-1
      // To calculate: (containerWidth - 3*gap) / 4.5 gives roughly right proportion
      // 3 squares = 3 units, 1 rect ~= 1.5 units = 4.5 units total
      const gap = 16
      const totalGaps = 3 * gap
      return Math.floor((this.containerWidth - totalGaps) / 4.5)
    },
    // Mobile: 3 images per row, 2 squares + 1 flex
    mobileRowHeight() {
      const gap = 8 // gap-2 = 8px
      const totalGaps = 2 * gap
      // 2 squares + 1 rect (~1.5) = 3.5 units
      return Math.floor((this.mobileContainerWidth - totalGaps) / 3.5)
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.calculateSizes()
    })
    window.addEventListener('resize', this.calculateSizes)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.calculateSizes)
  },
  methods: {
    calculateSizes() {
      // Get the actual container width using ref
      const container = this.$refs.gridContainer
      if (container) {
        this.containerWidth = container.offsetWidth
        this.mobileContainerWidth = container.offsetWidth
      }
    }
  }
}
</script>
